export default {
	leftFill(total: number, row: number) {
		let remain = total % row;
		return remain ? row - remain : 0;
	},
	play(src: string,type: string){
		
	},
	bgMusicOff(){
		
	},
	bgMusicOn(){
		
	}
};
